export class RqManuallySkipStep {
    step: string

    constructor(step: string) {
        this.step = step
    }
}